import { observer, useLocalObservable } from "mobx-react-lite";
import React, { useCallback } from "react";
import { HowToAuthorizeSlide, ScreenResponsive } from "../../components";
import { Box, ButtonLayout, ButtonLink, useScreenSize } from "@telefonica/mistica";
import { strings } from "../../localization";
import { useNavigateCustom, useOpenFGTSApp } from "../../hooks";
import { PostBalanceInquiryRequestFetchStore } from "../../stores";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { useAnalytics } from "../../hooks/useAnalytics";

const HowToAuthorize: React.FC = observer(() => {
	const navigate = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { title, titleDesktop, subtitle, buttonPrimary, buttonSecondary, buttonPrimaryDesktop, screen } =
		strings.pages.howToAuthorize;
	const { authenticationStore } = useGlobalStore();
	const store = useLocalObservable(
		() => new PostBalanceInquiryRequestFetchStore(authenticationStore, () => navigate("/connect-fgts-balance")),
	);

	const onHandleAuthorize = useCallback(() => {
		const buttonName = isDesktopOrBigger ? buttonPrimaryDesktop : buttonPrimary;
		handleAnalyticEvent(buttonName);
		store.fetchShelf.fetch();
	}, []);

	const { addAnalyticEvent, updatePageView } = useAnalytics();

	const handleAnalyticEvent = (buttonName: string, component?: "body" | "header"): void => {
		addAnalyticEvent({
			action: "click.button",
			component: component ? component : "body",
			description: buttonName,
			step: "fgts:saiba-como-antecipar",
			value: "",
		}, {applySanitize: true});
	};

	const handleGoBack = React.useCallback(() => {
		handleAnalyticEvent(screen, "header");
		navigate(-1);
	}, []);


	React.useEffect(() => {
		updatePageView({
			name: "Vivo Money FGTS Saiba como Antecipar",
			pagePath: "/fgts/saiba-como-antecipar",
		});
	}, []);

	return (
		<ScreenResponsive onBack={handleGoBack} navigationTitle={screen}>
			<Box paddingTop={isDesktopOrBigger ? 24 : 0} paddingBottom={isDesktopOrBigger ? 24 : 0}>
				<Box paddingY={24} paddingTop={isDesktopOrBigger ? 80 : 24} paddingBottom={isDesktopOrBigger ? 80 : 56}>
					<HowToAuthorizeSlide
						title={isDesktopOrBigger ? titleDesktop : title}
						subtitle={!isDesktopOrBigger ? subtitle : ""}
						buttonTitle={isDesktopOrBigger ? buttonPrimaryDesktop : buttonPrimary}
						onSubmit={onHandleAuthorize}
						alignButton={isDesktopOrBigger ? "left" : "center"}
					/>
					{!isDesktopOrBigger && (
						<Box paddingTop={16}>
							<ButtonLayout>
								<ButtonLink
									onPress={() => {
										handleAnalyticEvent(buttonSecondary);
										useOpenFGTSApp();
									}}
									showSpinner={false}
									disabled={store.fetchShelf.loader.isLoading}
								>
									{buttonSecondary}
								</ButtonLink>
							</ButtonLayout>
						</Box>
					)}
				</Box>
			</Box>
		</ScreenResponsive>
	);
});

export default HowToAuthorize;
